import {Component, OnInit} from '@angular/core';
import {BaseDialog} from '../base-dialog';
import {NbDialogRef} from '@nebular/theme';
import {Router} from '@angular/router';
import {WelfareBaseProject} from '../../../class/welfare-base-project';

@Component({
  selector: 'app-save-dialog',
  templateUrl: './save-dialog.component.html',
  styleUrls: ['./save-dialog.component.css']
})
export class SaveDialogComponent<T extends WelfareBaseProject> extends BaseDialog<T> implements OnInit {

  project: T;

  constructor(dialogRef: NbDialogRef<T>, route: Router) {
    super(dialogRef, route);
  }

  ngOnInit() {
  }

  saveProject() {
    if (this.project) {
      if (!this.project.creationTime) {
        this.project.creationTime = new Date();
      } else {
        this.project.lastMod = new Date();
      }
      this.close(this.project);
    }
  }
}
